import React from "react";
import constants from "../../utilities/constants.json";
import UserFaceAlt from "../../assets/img/avatar-face.jpg";
import { useNavigate } from "react-router-dom";

const imageUrl = constants.profile_image;

const AllTimeWinners = ({
  title = "Prediction Contest",
  allTimeWinners = [],
}) => {
  const navigate = useNavigate();
  
  if (!allTimeWinners?.length) return null;
  const firstPlace = allTimeWinners.find((w) => w?.position === "first_place");
  const secondPlace = allTimeWinners.find((w) => w?.position === "second_place");
  const thirdPlace = allTimeWinners.find((w) => w?.position === "third_place");


  const redirect = (data) => {
    if (localStorage.webKey) {
      navigate("/mobile-user-profile", {
        state: { rank: null, user_id: data.user?._id.$oid },
      });
    }
  };

  return (
    <div style={styles.container} className="container-drift">
      <div style={styles.topBorderBar} />



      {/* Header */}



      <div style={styles.header}>
        {/* <span style={styles.seasonBadge}>FIFA World Cup 2026 Prediction Contest</span> */}
        <h1 style={styles.title}>
          {title} <span style={styles.titleRed}>Winners</span>
        </h1>
      </div>

      {/* Top Winners */}
      <div style={styles.topWinners}>
        {/* Second Place */}
        {secondPlace && (
          <div style={styles.secondPlace} onClick={() => redirect(secondPlace)}>
            <div style={styles.imageWrapperSmall}>
              <div style={styles.outerRingSilver}>
                <div style={styles.ringSilver}>
                  <img
                    src={
                      secondPlace?.image
                        ? imageUrl + secondPlace.image
                        : UserFaceAlt
                    }
                    alt={secondPlace?.name}
                    style={styles.avatarImage}
                    onError={(e) => (e.target.src = UserFaceAlt)}
                  />
                </div>
              </div>
              <span style={styles.badgeSilver}>2nd</span>
            </div>

            <h3 style={styles.nameSecondary}>{secondPlace?.name}</h3>
          
          </div>
        )}
        {/* First Place */}
        {firstPlace && (
          <div style={styles.firstPlace} onClick={() => redirect(firstPlace)}>
            <svg style={styles.crownIcon} viewBox="0 0 24 24" fill="currentColor">
              <path d="M5 16L3 7L8.5 11L12 4L15.5 11L21 7L19 16H5Z" />
              <rect x="5" y="18" width="14" height="4" rx="1.5" />
            </svg>

            <div style={styles.imageWrapperLarge}  >
              <div style={styles.outerRingGold}>
                <div style={styles.ringGold} >
                  <img
                    src={
                      firstPlace?.image
                        ? imageUrl + firstPlace.image
                        : UserFaceAlt
                    }
                    alt={firstPlace?.name}
                    style={styles.avatarImage}
                    onError={(e) => (e.target.src = UserFaceAlt)}
                  />
                </div>
              </div>
              <span style={styles.badgeGold}>1st</span>
            </div>

            <h3 style={styles.namePrimary}>{firstPlace?.name}</h3>
          
          </div>
        )}



        {/* Third Place */}
        {thirdPlace && (
          <div style={styles.thirdPlace} onClick={() => redirect(thirdPlace)}>
            <div style={styles.imageWrapperSmall}>
              <div style={styles.outerRingBronze}>
                <div style={styles.ringBronze}>
                  <img
                    src={
                      thirdPlace?.image
                        ? imageUrl + thirdPlace.image
                        : UserFaceAlt
                    }
                    alt={thirdPlace?.name}
                    style={styles.avatarImage}
                    onError={(e) => (e.target.src = UserFaceAlt)}
                  />
                </div>
              </div>
              <span style={styles.badgeBronze}>3rd</span>
            </div>

            <h3 style={styles.nameTertiary}>{thirdPlace?.name}</h3>
       
          </div>
        )}
      </div>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: "520px",
    margin: "0 auto",
    paddingHorizontal: "8px",
    paddingTop: "22px",
    paddingBottom:"22px",
    background: "#f2f8fe",
    backgroundSize: "200% 200%",
    borderRadius: "14px",
    boxShadow: "0 6px 18px rgba(23, 86, 123, 0.2)",
    fontFamily: "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif",
    position: "relative",
    overflow: "hidden",
    marginBottom: "16px",
  },

  topBorderBar: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    height: "3px",
    background:
      "linear-gradient(90deg, \
rgba(37,99,235,0) 0%, \
rgba(37,99,235,0.15) 10%, \
rgba(37,99,235,0.5) 20%, \
rgba(22,163,74,0.85) 35%, \
rgba(220,38,38,0.85) 65%, \
rgba(220,38,38,0.5) 80%, \
rgba(220,38,38,0.15) 90%, \
rgba(220,38,38,0) 100%)",

    zIndex: 2,
  },

  header: { textAlign: "center", marginBottom: "4px" },
  seasonBadge: {
    display: "inline-block",
    padding: "1px 10px",
    backgroundColor: "#f3f8fa",
    color: "#083fb5",
    marginBottom: 3,
    border: "1px solid #bcdcff",
    borderRadius: "9999px",
    fontSize: "10px",
    fontWeight: "700",
    letterSpacing: "0.01em",
  },
  title: { fontSize: "15px", fontWeight: "800", margin: "2px 0 0" },
  titleRed: { color: "#a51b1b" },

  topWinners: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-end",
    gap: "24px",
    marginBottom: "4px",
  },

  firstPlace: { display: "flex", flexDirection: "column", alignItems: "center" },
  secondPlace: { display: "flex", flexDirection: "column", alignItems: "center" },

 crownIcon: {
  width: "20px",
  height: "20px",
  color: "#211d8f",
  marginBottom: "1px",
},

  imageWrapperLarge: { position: "relative", marginBottom: "10px" },
  imageWrapperSmall: { position: "relative", marginBottom: "8px" },
  imageWrapperRunner: { position: "relative", marginBottom: "3px" },

  /* 🥇 GOLD — outer circle, sits around the existing gold ring */
 outerRingGold: {
  width: "78px",
  height: "78px",
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  border: "3px solid #1d458f",
  background: "#fff8e1",
  boxShadow: "0 0 0 2px #fff, 0 3px 8px rgba(8, 185, 234, 0.3)",
},

  /* 🥇 GOLD — inner circle (unchanged) */
  ringGold: {
    width: "66px",
    height: "66px",
    borderRadius: "50%",
    overflow: "hidden",
    border: "2px solid #1d458f",
    background: `
      radial-gradient(
        circle at 30% 30%,
        #ffeaea 0%,
        #f9caca 22%,
        #c12b2b 55%,
        #8f1d1d 100%
      )
    `,
    marginBottom: "1px"
  },

  /* 🥈 SILVER — outer circle */
 outerRingSilver: {
  width: "60px",
  height: "60px",
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  border: "3px solid #920707",
  background: "#fbeaea",
  boxShadow: "0 0 0 2px #fff, 0 3px 7px rgba(146,7,7,0.25)",
},
  /* 🥈 SILVER — inner circle (unchanged) */
  ringSilver: {
    width: "50px",
    height: "50px",
    borderRadius: "50%",
    overflow: "hidden",
    border: "2px solid #920707",
    background: `
      radial-gradient(
        circle at 30% 30%,
        #f1f5f9 0%,
        #d1d5db 25%,
        #9ca3af 55%,
        #6b7280 80%,
        #4b5563 100%
      )
    `,
    boxShadow: `
      inset 0 1px 2px rgba(255,255,255,0.35),
      inset 0 -2px 4px rgba(0,0,0,0.35),
      0 0 0 1px rgba(156,163,175,0.35),
      0 0 6px rgba(148,163,184,0.35)
    `,
  },

  ringRunner: {
    width: "36px",
    height: "36px",
    borderRadius: "50%",
    overflow: "hidden",
    border: "2px solid #e5e7eb",
  },

  badgeGold: {
    position: "absolute",
    bottom: "-2px",
    left: "50%",
    transform: "translateX(-50%)",
    padding: "0px 6px",
    backgroundColor: "#211d8f",
    color: "#fff",
    borderRadius: "9999px",
    fontSize: "10px",
    fontWeight: "700",
  },

  thirdPlace: { display: "flex", flexDirection: "column", alignItems: "center" },




  /* 🥉 BRONZE — outer circle */
outerRingBronze: {
  width: "60px",
  height: "60px",
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  border: "3px solid #92400e",
  background: "#fef3e2",
  boxShadow: "0 0 0 2px #fff, 0 3px 7px rgba(146,64,14,0.25)",
},

  /* 🥉 BRONZE — inner circle (unchanged) */
  ringBronze: {
    width: "50px",
    height: "50px",
    borderRadius: "50%",
    overflow: "hidden",
    border: "2px solid #92400e",
    background: `
      radial-gradient(
        circle at 30% 30%,
        #fef3c7 0%,
        #fbbf6f 25%,
        #d97706 55%,
        #92400e 100%
      )
    `,
    boxShadow: `
      inset 0 1px 2px rgba(255,255,255,0.35),
      inset 0 -2px 4px rgba(0,0,0,0.35),
      0 0 0 1px rgba(146,64,14,0.35),
      0 0 6px rgba(217,119,6,0.35)
    `,
  },

  badgeBronze: {
    position: "absolute",
    bottom: "-2px",
    left: "50%",
    transform: "translateX(-50%)",
    padding: "0px 6px",
    backgroundColor: "#92400e",
    color: "#fff",
    borderRadius: "9999px",
    fontSize: "7px",
    fontWeight: "700",
  },

  nameTertiary: {
    fontSize: "9px",
    fontWeight: "700",
    textAlign: "center",
    marginBottom: "3px",
    marginTop: "1px",
  },

  pointsBronze: { fontSize: "8px", fontWeight: "600", color: "#92400e" },

  badgeSilver: {
    position: "absolute",
    bottom: "-2px",
    left: "50%",
    transform: "translateX(-50%)",
    padding: "0px 6px",
    backgroundColor: "#920707",
    color: "#fff",
    borderRadius: "9999px",
    fontSize: "7px",
    fontWeight: "700",
  },

  namePrimary: {
    fontSize: "11px",
    fontWeight: "700",
    textAlign: "center",
    marginTop: "1px",
  },
  nameSecondary: {
    fontSize: "9px",
    fontWeight: "700",
    textAlign: "center",
    marginBottom: "3px",
    marginTop: "1px",
  },

  pointsGold: { fontSize: "9px", fontWeight: "700", color: "#a51b1b" },
  pointsSilver: { fontSize: "8px", fontWeight: "600", color: "#64748b" },

  avatarImage: { width: "100%", height: "100%", objectFit: "cover"},

  runnersSection: { marginTop: "8px" },

  runnersTitleContainer: {
    position: "relative",
    paddingLeft: "8px",
    marginBottom: "6px",
  },
  runnersBar: {
    position: "absolute",
    left: 0,
    top: "50%",
    transform: "translateY(-50%)",
    width: "3px",
    height: "10px",
    backgroundColor: "#d1d5db",
    borderRadius: "2px",
  },
  runnersTitle: {
    fontSize: "8px",
    fontWeight: "600",
    color: "#6b7280",
    letterSpacing: "0.08em",
    margin: 0,
  },

  runnersGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "6px",
  },

  runnerCard: {
    backgroundColor: "#f9fafb",
    borderRadius: "8px",
    padding: "6px 4px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },

  runnerName: {
    fontSize: "10px",
    fontWeight: "700",
    textAlign: "center",
    height: "20px",
    overflow: "hidden",
  },

  runnerPoints: {
    fontSize: "8px",
    color: "#6b7280",
    marginTop: "1px",
  },
};

export default AllTimeWinners;